import React, { useEffect } from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import Dashboard from './pages/admin/dashboard';
import UserDashboard from './pages/user/dashboard';
import {
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import UserManagement from './pages/admin/usermanagement';
import User from './pages/user/index';
import Admin from './pages/admin';
import AgencyManagement from './pages/admin/agencymanagment';
import Transaction from './pages/admin/tranction';
import Support from './pages/admin/support';
import Usermanagementsettings from './pages/admin/usermanagmentsetting';
import BuySell from './pages/user/BuySell/BuySell';
import SignUp from './auth/signup/signup';
import Login from './auth/login/login';
import ForgotEmail from './auth/forgotemail'
import FeedbackAndSuport from './pages/user/feedback';
import MyAssets from './pages/user/myassets';
import SwapCrypto from './pages/user/swapcrypto';
import UserTransaction from './pages/user/transaction';
import Verification from './verification';
import UserProfile from './pages/user/profile';
import Ticket from './pages/admin/ticket'
import UserTicket from './pages/user/ticket'
import AssestsManage from './pages/user/assestmanage'
import MarketPage from './pages/user/market';
import TrendingPage from './pages/user/trendingcoin';
import { ConfigProvider } from 'antd';
import { useSelector } from 'react-redux'
import LandingPage from './pages/landingpage';
import '../src/i18n';


function App() {

  return (
    <ConfigProvider
      theme={{
        token: {
          colorBgContainer: '#141f38',
          colorBgContainerDisabled: '#141f38',
          colorBorder: '#334155',
          colorText: '#94a3b8',
          colorTextDisabled: '#94a3b8',
          colorTextPlaceholder: '#94a3b8',
          colorPrimary: '#6c5dd3',
          colorPrimaryHover: '#6c5dd3',
          colorLinkActive: '#6c5dd3',
          colorLinkHover: '#6c5dd3',
          colorBgElevated: '#141f38',
          fontFamily: 'Nunito Sans'
        },
        components: {
          Input: {
            activeBorderColor: '#6c5dd3',
            hoverBorderColor: '#6c5dd3',
            activeShadow: '#6c5dd3'
          },
          Select: {
            optionActiveBg: '#2b374b',
            optionSelectedBg: '#343360',
            selectorBg: '#141f38',
          },
          Button: {
            defaultBorderColor: '#334155',
            defaultColor: '#E6E8F0'
          },
          Modal: {
            contentBg: '#0f172a'
          }
        },
      }}
    >
      <Routes>
        <Route path='/' element={<LandingPage />} />
        <Route path='/verification' element={<Verification />} />
        <Route path='login' element={<Login />} />
        <Route path='signup' element={<SignUp />} />
        <Route path='forgot-password' element={<ForgotEmail />} />

        <Route path='/admin' element={<Admin />}>
          <Route index element={<Dashboard />} />
          <Route path='dashboard' element={<Dashboard />} />
          <Route path='managment' element={<UserManagement />} />
          <Route path='managment/:id' element={<Usermanagementsettings />} />
          <Route path='agencymanagement' element={<AgencyManagement />} />
          <Route path='transaction' element={<Transaction />} />
          <Route path='support' element={<Support />} />
          <Route path='ticket/:id' element={<Ticket />} />
        </Route>

        <Route path='/user' element={<User />}>
          <Route index element={<UserDashboard />} />
          <Route path='dashboard' element={<UserDashboard />} />
          <Route path='buysell' element={<BuySell />} />
          <Route path='support' element={<FeedbackAndSuport />} />
          <Route path='wallet' element={<MyAssets />} />
          <Route path='wallet/manage' element={<AssestsManage />} />
          <Route path='swapcrypto' element={<SwapCrypto />} />
          <Route path='transaction' element={<UserTransaction />} />
          <Route path='profile' element={<UserProfile />} />
          <Route path='market' element={<MarketPage />} />
          <Route path='trendingcoins' element={<TrendingPage />} />
          <Route path='ticket/:id' element={<UserTicket />} />
        </Route>
      </Routes>
    </ConfigProvider>

  );
}
export default App;
